<template>
    <div class="w-full h-full">
        <Header title="Payouts" icon="BadgePoundSterling" />
        <SubHeader v-if="currentInvoiceData != undefined" title="Upcoming payout"
            subText="View the estimated totals for the current month's activity">
            <template v-slot:stats>
                <StatBox name="Estimated totals for:" :number="niceDateTimeForSubheader(currentInvoiceData.startDate)"
                    currency="" icon="Calendar" />
                <StatBox name="Accrued balance" :number="currentInvoiceData.amount" currency="£"
                    icon="BadgePoundSterling" />
                <StatBox name="User cashback" :number="currentInvoiceData.endUserAmount" currency="£"
                    icon="BadgePoundSterling" />
                <StatBox name="Your commission" :number="currentInvoiceData.commissionAmount" currency="£"
                    icon="BadgePoundSterling" />
            </template>
        </SubHeader>
        <WhiteBox class="" title="Payout History" subText="">
            <template v-slot:content>
                <EasyDataTable :table-min-height="0" :headers="headersTable1" :items="historicData" :loading="loading"
                    v-model:server-options="serverOptions" :server-items-length="serverItemsLength" :hide-footer="true"
                    :no-hover="true">
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                        <div class="flex justify-center py-4">
                            <div
                                class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                <p class="text-sm mr-2">No results</p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>

                    <template #item-action="historicData">
                        <div class="flex justify-end items-center py-1 gap-1">
                            <CustomButton small text="Download CSV" icon="FileDown" type="navigate"
                                @click="download(historicData.id)" />

                        </div>
                    </template>
                    <template #item-startDate="historicData">
                        <div class="w-20 py-1" style="font-size:11px;">
                            {{ niceDateTime(historicData.startDate) }}
                        </div>
                    </template>
                    <template #item-endDate="historicData">
                        <div class="w-20 py-1" style="font-size:11px;">
                            {{ niceDateTime(historicData.endDate) }}
                        </div>
                    </template>
                    <template #item-amount="historicData">
                        <div class="w-20 py-1" style="font-size:11px;">
                            £{{ historicData.amount.toFixed(2) }}
                        </div>
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import { DateTime } from 'luxon';
import Header from "@/components/Header.vue";
import SubHeader from "@/components/SubHeader.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import StatBox from "@/components/StatBox.vue";

export default {
    name: "view-payouts",
    components: {
        Header,
        WhiteBox,
        CustomButton,
        SubHeader,
        StatBox

    },
    props: {
    },

    data() {
        return {

            currentInvoiceData: undefined,
            historicData: [],
            serverOptions: {
                page: 1,
                rowsPerPage: 25,
            },
            serverItemsLength: undefined,
            showErrorModal: false,
            showSuccessModal: false,
            showFormModal: false,
            loading: true,
            headersTable1: [
                { text: "Start Date", value: "startDate" },
                { text: "End Date", value: "endDate" },
                { text: "Paid", value: "paid" },
                { text: "Total amount", value: "amount" },
                { text: "Action", value: "action" },


            ],
            apiKeys: [

            ],
        }
    },
    created() {
        this.getCurrentPayout()
        this.getHistoricPayouts(0, 25)

    },
    methods: {
        niceDateTime(dateObject) {
            return DateTime.fromMillis(dateObject).toLocaleString(DateTime.MED)
        },

        niceDateTimeForSubheader(dateObject) {
            return DateTime.fromMillis(dateObject).toFormat('MMMM yyyy')
        },

        async download(id) {
            try {
                const token = localStorage.getItem('token');
                const api = localStorage.getItem('apiType');

                this.loading = true;

                const response = await fetch(`https://${api}.boogi.io/private/api/client/payout/historic/${id}/csv`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    const blob = await response.blob(); // Convert the response to a blob
                    const url = window.URL.createObjectURL(blob); // Create a URL for the blob

                    // Create a link element and set its href to the blob URL
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `payout_historic_${id}.csv`); // Set the desired file name

                    document.body.appendChild(link);
                    link.click(); // Programmatically click the link to trigger download

                    document.body.removeChild(link); // Remove the link after the download is triggered
                } else {
                    console.error('Failed to download CSV');
                }
            } catch (error) {
                console.error('Error downloading CSV:', error);
            } finally {
                this.loading = false; // Stop loading
            }
        },

        async getCurrentPayout() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await fetch(`https://${api}.boogi.io/private/api/client/payout/current`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()

                    this.currentInvoiceData = object
                }

            } catch (error) {
                return;
            }

        },
        async getHistoricPayouts(page, size) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await fetch(`https://${api}.boogi.io/private/api/client/payout/historic?page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.historicData = object.content
                    this.serverItemsLength = object.totalElements
                    this.loading = false
                }

            } catch (error) {
                return;
            }

        },


    },
    computed: {

    },
    mounted() {
        document.title = "Dashboard | Payouts";
    },
    watch: {
        serverOptions: {
            deep: true,
            handler(val) {
                this.getHistoricPayouts(val.page - 1, val.rowsPerPage)
            }
        }
    }
}
</script>